import {FormInputType} from '../../../../blocks/FormBlock'
import {copy} from '../../../../../util/fieldscopy'

const emailField: FormInputType = {
	id: 0,
	parent_id: 0,
	channel: 'input',
	type: 'email',
	label: copy?.email || 'E-mailadres',
	name: 'emailaddress',
	placeholder: '',
	required: true
}

export default emailField
